import { SxProps, Theme } from '@mui/material';
import { AI_GRADIENT_CSS as AI_GRADIENT, aiGradientTextSx } from 'common/constants/ai';
import { getZoomAdjustedPx } from 'components/ui/utilities/zoom';

const getMappingToolbarPx = (value: number, zoomLevel: number) => getZoomAdjustedPx(value, zoomLevel);

export const getToolbarContainerSx = (zoomLevel: number): SxProps<Theme> => ({
  display: 'flex',
  gap: getMappingToolbarPx(8, zoomLevel),
  alignItems: 'center',
  my: getMappingToolbarPx(4, zoomLevel),
});

export const getCreateLabelsButtonSx = (zoomLevel: number): SxProps<Theme> => ({
  textTransform: 'none',
  whiteSpace: 'nowrap',
  border: 'none',
  py: getMappingToolbarPx(2, zoomLevel),
  px: getMappingToolbarPx(8, zoomLevel),
  minHeight: 0,
  lineHeight: 1.2,
  fontSize: getMappingToolbarPx(12, zoomLevel),
  '&:hover': {
    border: 'none',
    backgroundColor: 'transparent',
  },
  '&:hover .MuiTypography-root': {
    backgroundPosition: '100% 50%',
    filter: 'brightness(0.9)',
  },
});

export const getPushMappingsButtonSx = (zoomLevel: number): SxProps<Theme> => ({
  textTransform: 'none',
  whiteSpace: 'nowrap',
  py: getMappingToolbarPx(4, zoomLevel),
  px: getMappingToolbarPx(12, zoomLevel),
  lineHeight: 1.2,
  fontSize: getMappingToolbarPx(12, zoomLevel),
  flexShrink: 0,
  // Do not set minHeight: 0 (copied from text-only controls): it can collapse a contained
  // Button in the zoomed tab app bar, leaving only padding (~4px) and invisible label text.
});

export const getClearMappingsButtonSx = (zoomLevel: number): SxProps<Theme> => ({
  height: getMappingToolbarPx(28, zoomLevel),
  width: getMappingToolbarPx(28, zoomLevel),
  '& svg': {
    fontSize: getMappingToolbarPx(18, zoomLevel),
  },
});

export const menuItemAiIconSx: SxProps<Theme> = {
  width: 14,
  height: 14,
  marginRight: 1,
};

export const aiMenuItemTextSx: SxProps<Theme> = {
  ...(aiGradientTextSx as Record<string, unknown>),
  fontWeight: 500,
};

export const getCreateLabelsTextSx = (zoomLevel: number): SxProps<Theme> => ({
  ...(aiGradientTextSx as Record<string, unknown>),
  backgroundSize: '180% 100%',
  backgroundPosition: '0% 50%',
  fontWeight: 600,
  textTransform: 'none',
  fontSize: getMappingToolbarPx(12, zoomLevel),
  py: getMappingToolbarPx(2, zoomLevel),
  px: getMappingToolbarPx(10, zoomLevel),
  minHeight: 0,
  lineHeight: 1.4,
  display: 'flex',
  alignItems: 'center',
  maxWidth: '100%',
  minWidth: 0,
  overflow: 'hidden',
  position: 'relative',
  textOverflow: 'ellipsis',
  transition: 'background-position 220ms ease, filter 160ms ease',
  whiteSpace: 'nowrap',
  zIndex: 1,
  '&.Mui-disabled': { background: AI_GRADIENT, opacity: 0.45, color: 'white' },
});

export const popperSx: SxProps<Theme> = {
  zIndex: 1500,
};

export const getMenuPaperSx = (zoomLevel: number): SxProps<Theme> => ({
  maxWidth: getMappingToolbarPx(320, zoomLevel),
  maxHeight: getMappingToolbarPx(248, zoomLevel),
  overflow: 'hidden',
});

export const getMenuListSx = (zoomLevel: number): SxProps<Theme> => ({
  maxHeight: getMappingToolbarPx(248, zoomLevel),
  overflowY: 'auto',
  py: getMappingToolbarPx(4, zoomLevel),
});

export const getMenuItemSx = (zoomLevel: number): SxProps<Theme> => ({
  fontSize: getMappingToolbarPx(12, zoomLevel),
  lineHeight: getMappingToolbarPx(16, zoomLevel),
  minHeight: getMappingToolbarPx(32, zoomLevel),
  px: getMappingToolbarPx(12, zoomLevel),
  py: getMappingToolbarPx(7, zoomLevel),
  whiteSpace: 'normal',
});
